import { render, staticRenderFns } from "./Pk.vue?vue&type=template&id=74d8cdd5&scoped=true&"
import script from "./Pk.vue?vue&type=script&lang=js&"
export * from "./Pk.vue?vue&type=script&lang=js&"
import style0 from "./Pk.vue?vue&type=style&index=0&id=74d8cdd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d8cdd5",
  null
  
)

export default component.exports